// extracted by mini-css-extract-plugin
module.exports = {"container":"container--m5nhW9Ubyf","selection":"selection--v9hZx8GoOm"};